import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

import {ParametroFuncao, ParametroTipo} from 'src/app/funcao/models/parametro-funcao';

@Component({
  selector: 'app-parametro-funcao-composto',
  templateUrl: './parametro-funcao-composto.component.html',
  styleUrls: ['./parametro-funcao-composto.component.scss']
})
export class ParametroFuncaoCompostoComponent implements OnInit {

  @Input() schema: ParametroFuncao;
  @Input() formGroup: FormGroup;
  @Input() parentGroup: FormGroup;
  @Input() value: any;
  @Input() readonly = false;
  @Input() parametrosRegra;

  constructor() {
  }

  ngOnInit(): void {
    if (this.schema.obrigatorio) {
      this.formGroup.setValidators([this.requiredAtLeastOne()]);
    }

    this.formGroup.valueChanges.subscribe((value) => {

      this.schema.parametros.forEach((item) => {
        item.naoObrigatorioSe.forEach((requiredFieldName) => {
          let requiredFieldControl = this.formGroup
            .get(requiredFieldName);
          let currentFieldControl = this.formGroup
            .get(item.variavel);
          if (
            currentFieldControl != null && requiredFieldControl != null &&
            requiredFieldControl.value == null
          ) {
            currentFieldControl.setValidators(Validators.required)
            currentFieldControl.updateValueAndValidity({emitEvent: false});
          } else if (currentFieldControl != null && requiredFieldControl != null &&
            requiredFieldControl.value != null) {
            currentFieldControl.clearValidators();
            currentFieldControl.updateValueAndValidity({emitEvent: false});
          }
        });
      })
      this.schema.naoObrigatorioSe.forEach(requiredFieldName =>{
        let requiredFieldControl = this.parentGroup
          .get(requiredFieldName);
        let currentFieldControl = this.parentGroup
          .get(this.schema.variavel);

        if(requiredFieldControl != null &&
          currentFieldControl != null &&
          !this.formGroupIsEmpty(requiredFieldControl)){
          Object.keys((currentFieldControl as FormGroup).controls).forEach((control) => {
            currentFieldControl.get(control).clearValidators()
            currentFieldControl.get(control).updateValueAndValidity({emitEvent: false});
          })

        }
      })


    });
  }

  private formGroupIsEmpty(group) {
    let empty = true;
    Object.keys(group.controls).forEach((control) => {
      if (group.get(control).value !== null && group.get(control).value != '' ) empty = false;
    });
    return empty;
  }

  public requiredAtLeastOne(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      if (!group || Object.getOwnPropertyNames(group).length == 0)
        return;

      let valid = false;
      Object.keys(group.controls)?.forEach(control => {
        if (group.controls[control].value != null)
          valid = true;
      });

      return valid ? null : {empty: true};
    }
  }
}
